<template>
  <div>
    <Header />
    <Hero class="mb-5" />
    <Recordings />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Recordings from '@/components/Recordings.vue';
import Hero from '@/components/Hero.vue';

export default {
  components: {
    Header,
    Recordings,
    Hero,
  },
};
</script>

<style>
</style>
